import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from 'ionic-angular';

/*
  Generated class for the ErpPopupProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ErpPopupProvider {
  public duration: number;
  public position: string;
  constructor(
    public http: HttpClient,
    private translate: TranslateService,
    private toastCtrl: ToastController,
  ) {
    this.duration = 1500;
    this.position = 'bottom';
    console.log('Hello ErpPopupProvider Provider');
  }

  private _createToast(msg: string, duration: number, position: string) {
    return this.toastCtrl.create({
      message: msg,
      duration: duration,
      position: position,
    });
  }

  private _show(msg: string, cb?: any): void {
    let toast = this._createToast(msg, this.duration, this.position);
    if (typeof cb === 'function') {
      toast.onDidDismiss(() => {
        cb();
      });
    }
    toast.present();
  }

  /**
   * method show toast ionic
   * @param msg message
   * @param cb callback
   */
  show(msg: string, cb?: any) {
    const txtMsg = this.translate.instant(msg);
    this._show(txtMsg, cb);
  }
  
  /**
   * method show toast ionic
   * @param msg message
   * @param cb callback
   */
  showNoTranslate(msg: string, cb?: any) {
    this._show(msg, cb);

  }

}



// WEBPACK FOOTER //
// ./src/providers/erp-popup/erp-popup.ts